// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import VideoPlayer from 'vue-video-player'
import 'babel-polyfill'

require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)


// import ElementUi from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
// Vue.use(ElementUi)

// IE9,10,11 不兼容axios 的回调方法 处理方案
// import promise from 'es6-promise';
// promise.polyfill(); 

import { MessageBox, Button, Dialog } from 'element-ui'
Vue.use(Button)
Vue.use(Dialog)
Vue.prototype.$msgbox = MessageBox;

import VueJsonp from 'vue-jsonp'
Vue.use(VueJsonp)

import versionNav from './components/qqsmVersion_nav.vue'
Vue.config.productionTip = false
Vue.component('versionNav', versionNav);
router.beforeEach((to, from, next) =>
{ //导航跳转
    var explorer = navigator.userAgent;
    if (explorer.indexOf("Chrome") >= 0)
    {
        // chrome
        document.body.scrollTop = 0
    }
    else if (explorer.indexOf("Firefox") >= 0)
    {
        // firefox
        document.documentElement.scrollTop = 0
    }
    else if (explorer.indexOf("Safari") >= 0)
    {
        // safari
    window.pageYOffset = 0
    } 

    next()
})

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: {
        App
    },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js